import { OwnershipRecentDocument } from '@commenda/api';
import { FileTypeIcon } from '@commenda/kakashi';

import { viewUploadedFile } from '../../../service-request/utils';

interface RecentDocumentsCardProps {
  documents: OwnershipRecentDocument[];
  onViewAll?: () => void;
}

export const RecentDocumentsCard = ({
  documents,
  onViewAll,
}: RecentDocumentsCardProps) => (
  <div className="flex w-full flex-col gap-lg rounded-md border-[0.5px] border-border-primary bg-bg-primary p-xl shadow-[0px_2px_4px_rgba(0,0,0,0.04)]">
    <div className="flex w-full items-center justify-between">
      <h3 className="txt-extra-small-bold text-text-primary">
        Recent documents
      </h3>
      {onViewAll && (
        <button
          type="button"
          onClick={onViewAll}
          className="py-xs txt-extra-small-medium text-fg-brand hover:opacity-80"
        >
          View all
        </button>
      )}
    </div>

    {documents.length === 0 ? (
      <p className="w-full txt-extra-small-regular text-text-secondary">
        No ownership documents uploaded.
      </p>
    ) : (
      <ul className="flex w-full flex-col gap-md">
        {documents.map((doc) => (
          <li key={doc.id}>
            <button
              type="button"
              onClick={() => viewUploadedFile(doc.id)}
              className="flex w-full items-center gap-lg rounded-md border-[0.5px] border-border-primary bg-bg-primary p-lg text-left transition-colors hover:bg-bg-secondary"
            >
              <FileTypeIcon
                extension={doc.extension}
                className="size-6 shrink-0"
              />
              <span className="flex-1 min-w-0 truncate txt-small-medium text-text-primary">
                {doc.fileName}
              </span>
            </button>
          </li>
        ))}
      </ul>
    )}
  </div>
);
